import { Tooltip, TooltipProps } from '@material-ui/core';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import * as Colors from 'src/theme/colors';

const useStyles = makeStyles()((theme) => ({
  tooltipContent: {
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)} ${theme.spacing(
      1,
    )} ${theme.spacing(1)}`,
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.DividersAndCardBorders}`,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export const DescriptionTooltip: React.FC<TooltipProps> = ({
  title,
  placement = 'bottom-start',
  children,
  ...rest
}) => {
  const { classes } = useStyles();
  return (
    <Tooltip
      title={title}
      placement={placement}
      classes={{
        tooltip: classes.tooltipContent,
      }}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};
